import { ApiHttpService } from '../ApiHttpService';
import { InfoAndQuestionsSerializer } from '../serializers/InfoAndQuestionsSerializer';
import { InfoAndQuestions } from '../../models/InfoAndQuestions';

const MESSAGE_PATH = 'Usuario/Mensaje';

class MessageController {
  static async getMessage(token) {
    const body = {
      Token: token,
    };
    const response = await ApiHttpService.post(`${MESSAGE_PATH}`, body, false, {});
    const deSerializedData = InfoAndQuestionsSerializer.deSerialize(response.data);
    return new InfoAndQuestions(deSerializedData);
  }
}

export { MessageController };



// WEBPACK FOOTER //
// ./src/networking/controllers/MessageController.js